import { capitalize } from "helpers/utils/utils_general";
import i18n from "i18n";

const filters = [
  {
    label: i18n.t("branch.office"),
    options: [
      {
        id: "1",
        label: "op1",
        value: "op1",
      },
      {
        id: "2",
        label: "op2",
        value: "op2",
      },
      {
        id: "3",
        label: "op3",
        value: "op3",
      },
      {
        id: "4",
        label: "op4",
        value: "op4",
      },
    ],
    selectedOption: {
      id: "1",
      label: "op1",
      value: "op1",
    },
    placeholder: i18n.t("select"),
  },
  {
    label: i18n.t("zone"),
    selectedOptions: null,
    placeholder: i18n.t("select"),
  },
  {
    label: capitalize(i18n.t("sector")),
    selectedOptions: null,
    placeholder: i18n.t("select"),
  },
];

export default filters;
